import React from 'react';
import NextImage from 'next/legacy/image';
import fastlyLoader from '../utils/fastlyLoader';

export default function Image(props) {
  return <NextImage { ...props } loader={ fastlyLoader } />;
}
